import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { Form781AData, RolodexEntryType } from 'types'

export interface InspectionAreaForm {
  formId: string
  formName: string
}

/**
 * Hook to get 781A forms that have at least one annotation in the given inspection area.
 */
export function useInspectionAreaForms(
  kestrelModelId: string | undefined,
  inspectionAreaId: string | undefined
): {
  forms: InspectionAreaForm[]
  isLoading: boolean
} {
  const { entries: allForm781AEntries, hasEverLoaded } = useRolodexEntries(
    kestrelModelId
      ? {
          type: RolodexEntryType.FORM_781A,
          tags: { 'kestrel-model': kestrelModelId },
        }
      : undefined
  )

  const forms = useMemo(() => {
    if (!inspectionAreaId || allForm781AEntries.length === 0) {
      return []
    }

    const matchingForms: InspectionAreaForm[] = []

    for (const entry of allForm781AEntries) {
      const formData = entry.data.formData as Form781AData | undefined
      if (!formData?.entries) continue

      const hasEntryInArea = formData.entries.some(
        (e) => e.inspectionAreaId === inspectionAreaId
      )

      if (hasEntryInArea) {
        matchingForms.push({
          formId: entry.id,
          formName: formData.name || `Form ${entry.id.slice(0, 8)}`,
        })
      }
    }

    return matchingForms
  }, [allForm781AEntries, inspectionAreaId])

  return {
    forms,
    isLoading: !hasEverLoaded,
  }
}
